// extracted by mini-css-extract-plugin
export default {"common":"Styles_common__xhAFM","mobile":"Styles_mobile__7bOJF"};